import { UserManager } from 'oidc-client';

class AuthService {
  constructor() {
    const settings = {
      authority: process.env.VUE_APP_AUTHORITY,
      metadataUrl: `${process.env.VUE_APP_AUTHORITY}.well-known/openid-configuration/`,
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
      redirect_uri: process.env.VUE_APP_REDIRECT_URI_AUTH,
      post_logout_redirect_uri: process.env.VUE_APP_REDIRECT_LOGOUT,
      response_type: process.env.VUE_APP_RESPONSE_TYPE_AUTH,
      scope: process.env.VUE_APP_SCOPE_AUTH,
      userStore: this.sessioznStorage,
      loadUserInfo: false
    };
    this.userManager = new UserManager(settings);
  }

  getUser() {
    return this.userManager.getUser();
  }

  login() {
    return this.userManager.signinRedirect();
  }

  renewToken() {
    return this.userManager.signinSilent();
  }

  signinRedirectCallback() {
    return this.userManager.signinRedirectCallback();
  }

  logout() {
    return this.userManager.signoutRedirect();
  }

}

const authservice = new AuthService();

export default authservice;
